<template>
  <custom-vue-select
    id="organizer-select"
    label="Organizer"
    :rules="rules"
    :options="options"
    :data-provider="getOrganizers"
    :selected.sync="organizerProxy"
    :text-field="option=>option.name"
    :disabled="$attrs.disabled||disableOnSelectFirstOption"
    @select="redirectIfAddOrganizerSelected"
  />
</template>

<script>
import CustomVueSelect from '../FormInputs/CustomVueSelect.vue'

export default {
  name: 'OrganizerSelect',
  components: { CustomVueSelect },
  props: {
    organizer: { type: [Object, Array], default: () => [] },
    rules: { type: [String, Object], default: '' },
  },
  data() {
    return {
      options: [],
    }
  },
  computed: {
    initialOptions() {
      return this.$attrs['able-to-add-organizer'] ? [{ name: 'Add new organizer' }] : []
    },
    organizerProxy: {
      get() {
        return this.organizer
      },
      set(value) {
        return this.$emit('update:organizer', value)
      },
    },
    disableOnSelectFirstOption() {
      return !!(this.$attrs['select-first-option'] && this.options.length < 2)
    },
  },
  created() {
    this.getOrganizers()
  },
  methods: {
    redirectIfAddOrganizerSelected(selected) {
      if (selected.name === this.initialOptions[0].name) {
        this.$router.push({ name: 'organizer-add' })
      }
    },
    getOrganizers(query) {
      return this.$http.axiosIns.get('organizer', {
        params: {
          name: query,
          organization: this.$orgId,
        },
      }).then(res => {
        this.options = [...res.data.data, ...this.initialOptions] || this.initialOptions
        if (this.$attrs['select-first-option'] && res.data.data.length === 1) { [this.organizerProxy] = res.data.data }
      })
    },
  },
}
</script>

<style>

</style>
